import ObjectCache from './CacheService';
import LogicBaseAppPinApi from '../server/LogicBaseAppPinApi';
import UserAccount from '../UserAccount';
import LogicBaseAppPin from '../../models/logicbaseapppin';

class LogicBaseAppPinCache extends ObjectCache {
  api = LogicBaseAppPinApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseAppPin(results._id, results.fr, results.a);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseAppPinCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
